import type { ReactNode } from 'react';
import { useIsPhone } from '../hooks/useMediaQuery';

/**
 * Secondary detail: always open on a large display, one tap away on a phone.
 * This is what keeps the mobile screen a priority feed instead of a long scroll.
 */
export function Collapsible({
  summary,
  children,
  defaultOpen = false,
}: {
  summary: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  const isPhone = useIsPhone();
  if (!isPhone) return <>{children}</>;
  return (
    <details className="panel" open={defaultOpen}>
      <summary
        className="panel__title"
        style={{ cursor: 'pointer', minHeight: 44, display: 'flex', alignItems: 'center' }}
      >
        {summary}
      </summary>
      <div className="stack" style={{ marginTop: 12 }}>
        {children}
      </div>
    </details>
  );
}
